import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LoadingButton,
} from '@cmg/design-system';

export type Props = Readonly<{
  isOpen: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
  investorName: string;
}>;

const DeleteIndicationConfirmDialog: React.FC<Props> = ({
  isOpen,
  isDeleting,
  onClose,
  onDelete,
  investorName,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Delete Indication</DialogTitle>

      <DialogContent dividers>
        Are you sure you want to delete the {investorName} Indication? This action will remove the
        indication from the view of all deal participants.
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <LoadingButton variant="contained" onClick={onDelete} loading={isDeleting}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteIndicationConfirmDialog;
